import { LtlPipelineViewModel } from "../../../ViewModel/LtlPipelineViewModel";
import { EditProjectContextProps } from "../../EditProjectContext";
import { getLtlWithFetchedBidpack } from "./GetLtlWithFetchedBidpack";
import { getSpdrShipFrequency } from "./GetSpdrShipFrequency";

export async function setLtlBidpackAndShipFrequency(
  spdrOrPdsrId: number | undefined,
  ltlPipeline: LtlPipelineViewModel,
  editProjectContext: EditProjectContextProps
) {
  const { project, setProject } = editProjectContext;

  const ltlWithBidpack = await getLtlWithFetchedBidpack(
    ltlPipeline,
    project.StartDateDisplay
  );

  if (ltlWithBidpack.SupplierShipFrequency === undefined) {
    ltlWithBidpack.SupplierShipFrequency = await getSpdrShipFrequency(
      ltlWithBidpack.SpdrId
    );
  }

  const ltlPipelines = project?.ltlPipelines?.map((ltlPipelineItem) => {
    if (
      ltlPipelineItem.SpdrId !== spdrOrPdsrId &&
      ltlPipelineItem.PdsrId !== spdrOrPdsrId
    ) {
      return ltlPipelineItem;
    }
    return {
      ...ltlWithBidpack,
    };
  });

  setProject({ ...project, ltlPipelines });
}
